/*
 * Project: forca
 * File Created: Thursday, 16th September 2021 1:28:40 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { useState } from 'react';

import Icon from '@Components/icon';

import { AccordionProps } from './accordion.definition';

export const Accordion = (props: AccordionProps) => {
	const {
		headline,
		subHeadline,
		content,
		children = null,
		cta,
		expanded = false,
		disabled = false,
		fullWidth = false,
		id
	} = props;

	const [isExpanded, changeExpanded] = useState(expanded);
	const targetIsString = typeof cta?.target === 'string';

	return (
		<div
			className={ [
				'Accordion',
				disabled ? 'Accordion--isDisabled' : ''
			].join(' ') }
		>
			<div className="Accordion-Headline" onClick={ () => changeExpanded(!isExpanded) }>
				{ isExpanded && <Icon icon="icon-minus-line" /> }
				{ !isExpanded && <Icon icon="icon-plus-line" /> }
				<div
					className={ [
						cta?.url ? 'Accordion-HeadlineWrapper' : ''
					].join(' ') }
				>
					{ headline }
					{ subHeadline && (
						<span className="Accordion-SubHeadline">{ subHeadline }</span>
					) }
				</div>
			</div>
			<div
				id={ id }
				className={ [
					'Accordion-Content',
					isExpanded ? 'Accordion-Content--isActive' : '',
					fullWidth ? 'Accordion-Content--fullWidth' : ''
				].join(' ') }
			>
				{ children ? children : (
					<div dangerouslySetInnerHTML={ { __html: content } } />
				) }
			</div>

			{ cta?.url && (
				<a href={ cta.url } target={ targetIsString ? cta.target : cta.target ? '_target' : '' } className="Accordion-CTA">
					<div className="Accordion-CTAText">
						{ cta.category && <span className="Accordion-CTA-category">{ cta.category }</span> }
						<strong className="Accordion-CTATitle">{ cta.title }</strong>
					</div>
					<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.34963 0.995583L8.4207 8.06665L1.34963 15.1377" stroke="#92004D" strokeWidth="2" />
					</svg>
				</a>
			) }
		</div>
	);
};

export default Accordion;